<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button type="warning" size="small" @click="openCreate" icon="el-icon-plus"/>
        </div>

        <el-table
                class="data-table"
                :data="tableData"
                stripe fit
                style="width: 100%">
            <el-table-column
                    v-for="item in  [
                      {label:'Name',prop:'name'},
                      {label:'Max Slots Per (D / W / M)',fmt:maxSlotFmt},
                      {label:'Max Adv. Book Period',prop:'maxAdvBook'},
                      {label:'Created',prop:'created',fmt:selfTimeFormat},
                      {label:'Updated',prop:'updated',fmt:selfTimeFormat}]"
                    :width="item.width"
                    :prop="item.prop"
                    :label="item.label"
                    :formatter="item.fmt"
                    :key="item.prop">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action"
                    width="200px">
                <template slot-scope="s">
                    <el-button type="primary" @click="openEdit(s.row)" size="mini" icon="el-icon-edit">Edit</el-button>
                    <el-button type="danger" @click="deleteData(s.row.id)" size="mini" icon="el-icon-delete">Del</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
                v-if="showEditDialog"
                center
                :close-on-click-modal="false"
                :visible.sync="showEditDialog"
                width="50%">
            <el-form ref="form" :model="form" label-width="200px" label-position="left">
                <el-form-item required label="Name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item required label="Picture">
                    <icon-uploader :url.sync="form.pic.path" :fid.sync="form.fid"></icon-uploader>
                </el-form-item>

                <el-form-item label="Max Slots Booked by a Unit (Off-Peak)" class="slots-conf" required>
                    <el-input v-model="form.maxSlotDay">
                        <template slot="prepend">Day</template>
                    </el-input>
                    <el-input v-model="form.maxSlotWeek">
                        <template slot="prepend">Week</template>
                    </el-input>
                    <el-input v-model="form.maxSlotMonth">
                        <template slot="prepend">Month</template>
                    </el-input>
                </el-form-item>

                <el-form-item label="Max Slots Booked by a Unit (Peak)" class="slots-conf">
                    <el-input v-model="form.maxSlotDayPeak">
                        <template slot="prepend">Day</template>
                    </el-input>
                    <el-input v-model="form.maxSlotWeekPeak">
                        <template slot="prepend">Week</template>
                    </el-input>
                    <el-input v-model="form.maxSlotMonthPeak">
                        <template slot="prepend">Month</template>
                    </el-input>
                </el-form-item>

                <el-form-item label="Max Concurrent Booking">
                    <el-input-number v-model="form.concurrent" :min="0"></el-input-number>
                    <el-checkbox class="check-box" v-model="form.slotConvert">Peak Slots can convert to Off-Peak Slots
                    </el-checkbox>
                </el-form-item>

                <el-form-item label="Adv booking Type">
                    <el-select v-model="form.advBookingType" placeholder="Select a type">
                        <el-option
                                v-for="item in [{label:'Day',value:1},{label:'Month',value:2}]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Min. Adv. Booking">
                    <el-input-number v-model="form.minAdvBook" :min="0" label="label"></el-input-number>
                </el-form-item>

                <el-form-item label="Max. Adv. Booking">
                    <el-input-number v-model="form.maxAdvBook" :min="0" label="label"></el-input-number>
                </el-form-item>

                <el-form-item label="Description">
                    <el-input v-model="form.description" type="textarea" placeholder="Enter description" :autosize="{ minRows: 2 }"></el-input>
                </el-form-item>

                <el-form-item label="Terms & Conditions" prop="terms">
                    <div class="item-add-btn">
                        <el-button type="warning" size="small" icon="el-icon-plus" @click="terms.push({})"></el-button>
                    </div>

                    <div v-for="(item,index) in terms" :key="'sn'+index">
                        <el-input v-model="item.title">
                            <template slot="prepend">Term {{index+1}}</template>
                            <el-button slot="append" icon="el-icon-delete" type="danger"
                                       @click="terms.splice(index,1)"></el-button>
                        </el-input>
                        <el-input v-model="item.content" type="textarea" :autosize="{ minRows: 2 }">
                        </el-input>
                    </div>
                </el-form-item>

                <el-form-item label="Multi slot">
                    <el-switch v-model="form.multiSlot" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>

                <el-form-item label="Require Approval?">
                    <el-switch v-model="form.approvalFlag" active-color="#13ce66" :active-value="1" :inactive-value="0"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>

                <el-form-item label="Overwrite Max Booking When Slot is Available">
          <el-switch :active-value="true" :inactive-value="false" active-color="#13ce66"
                     inactive-color="#ff4949"
                     v-model="form.allowAdditional"></el-switch>
        </el-form-item>

        <el-form-item label="Hours" v-if="form.allowAdditional">
          <el-input-number :min="0" label="label" v-model="form.additionalTime"></el-input-number>
                </el-form-item>
            </el-form>

            <span class="dialog-footer" slot="footer">
                <el-button @click="showEditDialog = false" size="medium">Cancel</el-button>
                <el-button type="primary" size="medium" @click="save">Save</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import {facilityTypes, facilityTypesCreate, facilityTypesDelete, facilityTypesUpdate} from '@/api/Facitliy'
import IconUploader from '../../../components/IconUploader'

export default {
  name: 'FacilityType',
  components: {IconUploader},
  data() {
    return {
      tableData: [],
      loading: false,
      form: {},
      showEditDialog: false,
      terms: [],
    }
  },
  methods: {
    loadData() {
      facilityTypes()
          .then(res => {
            this.tableData = res.data
          })
    },
    maxSlotFmt(row) {
      let day = Math.max(row.maxSlotDayPeak, row.maxSlotDay)
      let week = Math.max(row.maxSlotWeekPeak, row.maxSlotWeek)
      let month = Math.max(row.maxSlotMonthPeak, row.maxSlotMonth)
      return `${day} /${week} /${month}`
    },
    openCreate() {
      this.form = {
        pic: {}
      }
      this.showEditDialog = true
    },
    openEdit(data) {
      this.form = this.$copy(data)
      this.pic = this.form.pic.path
      this.terms = JSON.parse(this.form.termsCondition)
      this.showEditDialog = true
    },
    save() {
      const action = this.form.id ? facilityTypesUpdate : facilityTypesCreate
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.termsCondition = JSON.stringify(this.terms)
          delete this.form.pic
          action(this.form)
              .then(() => {
                this.loadData()
                this.showEditDialog = false
              })
        }
      })
    },
    deleteData(id) {
      this.$deleteRequest(this, facilityTypesDelete, id)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>
.slots-conf div {
  display: inline-table !important;
  width: 230px;
}

.check-box {
  margin-left: 6px;
}

    .el-button{
        margin-right: 5px;
    }
</style>
